/** Birim tipi */
export type QuoteUnit = 'm²' | 'adet' | 'kg' | 'paket';

/**
 * Markaya ve kategoriye göre varsayılan birim döndürür.
 * - QUA, Duratiles → m² (seramik/karo)
 * - Creavit → kategori bazlı: karo/seramik varsa m², aksi halde adet
 * - VitraFix ve diğerleri → adet
 */
export function defaultUnit(brand: string, category?: string): QuoteUnit {
  const b = brand.toLowerCase();
  const c = (category || '').toLowerCase();

  if (b.includes('qua') || b.includes('duratile')) return 'm²';

  if (b.includes('creavit')) {
    if (c.includes('karo') || c.includes('seramik')) return 'm²';
    return 'adet';
  }

  return 'adet';
}
